import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { QuestionMultiStepper } from 'src/app/core/models/questionnaire.model';
import { QuestionAnswer } from '../question/question.component';

@Component({
  selector: 'app-question-multi-stepper',
  templateUrl: './question-multi-stepper.component.html',
  styleUrls: ['./question-multi-stepper.component.scss'],
})
export class QuestionMultiStepperComponent implements OnInit {
  @Input('question') question!: QuestionMultiStepper;
  @Output('changeAnswer') changeAnswer: EventEmitter<QuestionAnswer> =
    new EventEmitter();

  stepperValues: { [key: string]: number } = {};

  constructor() {}

  ngOnInit(): void {
    // Set isValid to true from the start
    this.question.isValid = true;
    
    // Initialize with default values
    if (!this.question.answer?.addtional_information) {
      this.question.configuration.options.forEach((option) => {
        this.stepperValues[option.key] = option.default_value || option.min || 0;
      });
      this.question.answer = {
        value: this.buildValueString(),
        addtional_information: { ...this.stepperValues },
      };
    } else {
      this.stepperValues = { ...this.question.answer.addtional_information };
      // Ensure value is also set when restoring from existing data
      this.question.answer.value = this.buildValueString();
    }
    this.change();
  }

  /**
   * Builds a string representation of the stepper values for the `value` field
   * Example: "adults: 2, children: 0, rooms: 1"
   */
  private buildValueString(): string {
    const parts = this.question.configuration.options.map((option) => {
      const value = this.stepperValues[option.key] ?? option.default_value ?? 0;
      return `${option.value}: ${value}`;
    });
    return parts.join(', ');
  }

  increment(optionKey: string, max: number) {
    if (this.stepperValues[optionKey] < max) {
      this.stepperValues[optionKey]++;
      this.updateAnswer();
    }
  }

  decrement(optionKey: string, min: number) {
    if (this.stepperValues[optionKey] > min) {
      this.stepperValues[optionKey]--;
      this.updateAnswer();
    }
  }

  updateAnswer() {
    this.question.answer!.value = this.buildValueString();
    this.question.answer!.addtional_information = { ...this.stepperValues };
    this.question.isValid = true;
    this.change();
  }

  change() {
    setTimeout(() => {
      this.question.isValid = true;
      this.changeAnswer.next({
        answer: this.question.answer!,
        question: this.question,
      });
    }, 10);
  }
}
